import { Sparkles } from "lucide-react";
import WellnessQuiz from "./WellnessQuiz";

const SCIENCE_IMG = "/hero/quiz-aesthetic.png";
const QUIZ_HORIZON_IMG = "/hero/quiz-horizon-duo.png";

export default function ExplorerSection({ t, language }) {
  return (
    <section
      id="discover"
      data-testid="explorer-section"
      className="py-24 md:py-32 bg-[#f0ebe1]/60"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Intro */}
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-7">
            <p className="text-overline">{t.explorer.overline}</p>
            <h2
              className="font-serif font-light tracking-tight leading-[1.05] text-4xl md:text-5xl mt-5 text-[#1a2421] max-w-2xl"
              data-testid="explorer-title"
            >
              {t.explorer.title}
            </h2>
            <p className="mt-6 text-lg leading-relaxed text-[#5c6b61] max-w-xl">
              {t.explorer.body}
            </p>
          </div>
          <div className="lg:col-span-5">
            <img
              src={SCIENCE_IMG}
              alt="Cellular science"
              className="w-full h-[260px] md:h-[320px] object-cover rounded-3xl"
              loading="lazy"
            />
          </div>
        </div>

        {/* Quiz CTA card */}
        <div
          id="quiz"
          data-testid="quiz-cta-card"
          className="mt-16 grid lg:grid-cols-12 gap-0 bg-[#2c4a3b] rounded-3xl overflow-hidden shadow-[0_30px_80px_-30px_rgba(44,74,59,0.45)] scroll-mt-24"
        >
          <div className="lg:col-span-7 p-10 md:p-14 text-[#f9f6f0]">
            <div className="inline-flex items-center gap-2 bg-[#bc6c25]/20 text-[#f0c79f] rounded-full px-3 py-1.5 text-xs font-semibold uppercase tracking-[0.18em]">
              <Sparkles className="w-3.5 h-3.5" />
              {t.quiz.heroOverline}
            </div>
            <h3 className="font-serif font-light leading-[1.05] text-3xl md:text-5xl mt-6">
              {t.quiz.heroTitle}
            </h3>
            <p className="mt-5 text-base md:text-lg text-[#f9f6f0]/80 leading-relaxed max-w-xl">
              {t.quiz.heroBody}
            </p>

            <div className="mt-9">
              <WellnessQuiz t={t} language={language} />
            </div>

            <ul className="mt-10 grid sm:grid-cols-3 gap-x-6 gap-y-3 text-sm text-[#f9f6f0]/75 border-t border-white/10 pt-7">
              {[
                language === "es"
                  ? "10 preguntas · 30 segundos"
                  : "10 questions · 30 seconds",
                language === "es"
                  ? "Infografía descargable"
                  : "Downloadable infographic",
                language === "es"
                  ? "100% gratuito · Sin compromiso"
                  : "100% free · No commitment",
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#bc6c25]" />
                  {item}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-5 relative min-h-[280px] hidden lg:block">
            <div
              className="absolute inset-0 bg-cover bg-center"
              style={{ backgroundImage: `url(${QUIZ_HORIZON_IMG})` }}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#2c4a3b] via-[#2c4a3b]/40 to-transparent" />
          </div>
        </div>
      </div>
    </section>
  );
}
